import {
    ChatHistoryPageQuery,
    ChatMessage,
    ChatSessionsPageState,
} from 'src/app/cyn/chat-module/types/chat-session.types';

export const FIRST_SESSIONS_PAGE: ChatSessionsPageState = {
    cursors: [null],
    index: 0,
};

export function normalizeSessionsPage(page?: ChatSessionsPageState | null): ChatSessionsPageState {
    if (!page || !Array.isArray(page.cursors) || page.cursors.length === 0) {
        return { ...FIRST_SESSIONS_PAGE, cursors: [...FIRST_SESSIONS_PAGE.cursors] };
    }

    const index = Number.isInteger(page.index) ? page.index : 0;

    if (index < 0 || index >= page.cursors.length) {
        return { ...FIRST_SESSIONS_PAGE, cursors: [...FIRST_SESSIONS_PAGE.cursors] };
    }

    return {
        cursors: [...page.cursors],
        index,
    };
}

export function cloneSessionsPage(page: ChatSessionsPageState): ChatSessionsPageState {
    return {
        cursors: [...page.cursors],
        index: page.index,
    };
}

export function sessionsPageBefore(page: ChatSessionsPageState): string | undefined {
    return page.cursors[page.index] ?? undefined;
}

export function buildOlderSessionsPage(
    current: ChatSessionsPageState,
    lastSessionId: string,
): ChatSessionsPageState {
    const nextIndex = current.index + 1;
    const cursors = current.cursors.slice(0, nextIndex);
    cursors[nextIndex] = lastSessionId;

    return { cursors, index: nextIndex };
}

export function buildNewerSessionsPage(current: ChatSessionsPageState): ChatSessionsPageState | null {
    if (current.index <= 0) {
        return null;
    }

    return {
        cursors: [...current.cursors],
        index: current.index - 1,
    };
}

export function normalizeHistoryQuery(query?: ChatHistoryPageQuery | null): ChatHistoryPageQuery {
    if (!query) {
        return {};
    }

    if (query.before) {
        return { before: query.before };
    }

    if (query.after) {
        return { after: query.after };
    }

    return {};
}

export function isTailHistoryQuery(query: ChatHistoryPageQuery): boolean {
    return !query.before && !query.after;
}

export function isHistoryCursorMessage(message: ChatMessage): boolean {
    const id = message.id;

    return typeof id === 'string'
        && id.length > 0
        && !id.startsWith('local-')
        && !id.startsWith('user-')
        && !id.includes('_block_');
}

export function getHistoryCursorId(messages: ChatMessage[], edge: 'first' | 'last'): string | null {
    const match = edge === 'first'
        ? messages.find(isHistoryCursorMessage)
        : [...messages].reverse().find(isHistoryCursorMessage);

    return match?.id ?? null;
}

export function historyQueriesMatch(
    requested: ChatHistoryPageQuery,
    event: { before?: string; after?: string },
): boolean {
    const requestedBefore = requested.before;
    const requestedAfter = requested.after;

    if (requestedBefore) {
        return !event.before || event.before === requestedBefore;
    }

    if (requestedAfter) {
        return !event.after || event.after === requestedAfter;
    }

    return !event.before && !event.after;
}
